var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { ESidebarActioningFrom, } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
import TransferTableComp from "./TransferTableComp";
import "../OrderBook/OrderBookStyleSheet/OrderbookTransferInTable.scss";
import ArnOrderBookSidebar from "./ArnOrderBookSidebar";
var OrderbookTransferInTable = function (props) {
    var _a, _b, _c, _d;
    var openSB = props.openSB, setOpenSB = props.setOpenSB, selectedRowDetails = props.selectedRowDetails, setSelectedRowDetails = props.setSelectedRowDetails, setOpenTOC = props.setOpenTOC;
    var handleTableRowClick = function (data) {
        var rowDetails = __assign({}, data);
        setOpenSB(true);
        setSelectedRowDetails(rowDetails);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "orderbook-transfer-in-table ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") },
            React.createElement(TransferTableComp, { columns: props.tableColumns, data: (_d = (_c = (_b = props === null || props === void 0 ? void 0 : props.tableData) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.orderBookData, rowOnClick: handleTableRowClick, showViewAll: props.showViewAll, viewAllOnClick: props === null || props === void 0 ? void 0 : props.viewAllOnClick, showShimmer: props === null || props === void 0 ? void 0 : props.showShimmer, selectedSortColumnVal: props === null || props === void 0 ? void 0 : props.defaultSortingColumnKey, callbackSorted: props === null || props === void 0 ? void 0 : props.callbackSorted, selectedSortVal: props.selectedSortVal })),
        openSB && selectedRowDetails && (React.createElement(ArnOrderBookSidebar, { openKey: openSB, setOpenKey: setOpenSB, rowData: selectedRowDetails, actioningFrom: ESidebarActioningFrom.ALL_TRANSACTIONS_TABLE, setOpenTOC: setOpenTOC }))));
};
export default OrderbookTransferInTable;
